import { createFileRoute } from '@tanstack/react-router'
import { samplesRepository } from '@/data/adapters/mock/samples.mock'

export const Route = createFileRoute('/$orgSlug/$clientSlug/samples')({
  loader: ({ context: { queryClient, client } }) =>
    Promise.all([
      queryClient.ensureQueryData({
        queryKey: ['samples', 'products', client.id],
        queryFn: () => samplesRepository.getProducts(client.id),
      }),
      queryClient.ensureQueryData({
        queryKey: ['samples', 'orders', client.id],
        queryFn: () => samplesRepository.getSampleOrders(client.id),
      }),
      queryClient.ensureQueryData({
        queryKey: ['samples', 'hero', client.id],
        queryFn: () => samplesRepository.getHeroProducts(client.id),
      }),
      queryClient.ensureQueryData({
        queryKey: ['samples', 'restocks', client.id],
        queryFn: () => samplesRepository.getRestocks(client.id),
      }),
    ]),
})
